export const SUPER_ADMIN_ID = '4514165225';
export const SUPER_ADMIN_COMPANY_NAME = 'AVENDRA SUPER ADMIN';
